<app-wrapper size="lg">
  <div>
    <app-content-row>
      <app-button-location-back (backClick)="goToTools()">戻る</app-button-location-back>
    </app-content-row>
  </div>
  <app-content-row>
    <app-card-content [showSeparator]="true">
      <app-card-content-head>
        <mat-icon class="card-content-head-icon">person_add</mat-icon>
        所属ユーザ一一括削除
      </app-card-content-head>
      <app-wrapper size="fluid">
        <app-content-row>
          <section class="flex flex-col gap-6">
            <!--ファイルのアップロード-->
            <div class="border-2 border-border-line rounded-md p-6 flex gap-6 flex-col">
              <p class="mb-0">
                CSVをアップロードします。１つのファイルで削除できる
                <span class="text-primary font-bold">上限は100件</span>です。超える場合はCSVファイルを分けて登録してください。
              </p>
              <div *ngIf="!isReadyToRegister">
                <label class="bg-gray-50 p-6 pr-12 rounded-md block cursor-pointer relative">
                  <input
                    #fileInput
                    type="file"
                    accept="text/csv"
                    (click)="onClick($event)"
                    (change)="onFileUpload($event)"
                    [disabled]="isCsvUploading"
                  />
                  <div class="absolute right-4 top-1/2 -translate-y-1/2">
                    <mat-spinner [diameter]="24" *ngIf="isCsvUploading"></mat-spinner>
                  </div>
                </label>
              </div>

              <!--エラーメッセージ-->
              <div class="flex flex-col gap-6" *ngIf="csvErrors.length > 0 && isCsvUploading === false">
                <p class="text-danger mb-0">{{ csvErrors.length }}件のエラーがあります。CSVを修正し再登録してください。</p>
                <div class="flex flex-col gap-2">
                  <div *ngFor="let csvError of csvErrors">
                    <app-alert-box
                      *ngIf="csvError.item !== 'csv'"
                      [closeable]="false"
                      class="[&_.alert-box]:p-2 [&_.alert-box]:gap-2"
                      type="danger"
                      >行番号 {{ csvError.recordIndex }} : {{ csvError.message }}。</app-alert-box
                    >
                    <app-alert-box
                      *ngIf="csvError.item === 'csv'"
                      [closeable]="false"
                      class="[&_.alert-box]:p-2 [&_.alert-box]:gap-2"
                      type="danger"
                      >{{ csvError.message }}。</app-alert-box
                    >
                  </div>
                </div>
              </div>

              <!--エラーがない場合に表示されるエリア-->
              <div class="border-2 border-border-line rounded-md p-6 flex gap-6 flex-col" *ngIf="isReadyToRegister">
                <!--CSVファイル変更エリア-->
                <div class="bg-success-50 text-success-700 flex gap-4 p-6 rounded-md">
                  <mat-icon class="text-success-500">check_circle</mat-icon>
                  <p class="mb-0 grow">{{ fileName }}</p>
                  <button matTooltip="CSVを変更する" matTooltipPosition="above" (click)="resetFile()">
                    <mat-icon class="align-bottom text-success-500">delete</mat-icon>
                  </button>
                </div>

                <!--削除メンバー確認エリア-->
                <p class="mb-0">
                  <span class="text-primary font-bold">まだ削除は完了してません。</span><br />
                  以下の内容を確認し、問題がなければ<span class="text-primary font-bold">「削除」</span
                  >を押し一括削除を開始します。修正が必要な場合は再度CSVをアップロードしてください。
                </p>
                <hr class="border-t-2 border-dashed border-border-line" />

                <div class="flex items-center">
                  <div class="hidden md:block md:min-w-[120px]"></div>
                  <div class="font-bold flex flex-wrap gap-2 mx-auto items-center">
                    <p class="mb-0 text-lg">
                      削除人数 : <span class="text-primary">{{ numOfCsvUsers }}名</span>
                    </p>
                    <p class="mb-0 text-sm">
                      ( 団体管理ユーザー : <span class="text-primary">{{ numOfOrganizationAdminUsers }}名</span> / 一般ユーザー :
                      <span class="text-primary">{{ numOfNonOrganizationAdminUsers }}名</span> )
                    </p>
                  </div>
                </div>

                <!--削除メンバーテーブル-->
                <app-table-overflow>
                  <table mat-table [dataSource]="dataSource" class="w-full">
                    <ng-container matColumnDef="lineNumber">
                      <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap">{{ HEADER_ITEM_NAMES[0] }}</th>
                      <td mat-cell *matCellDef="let element" class="text-sm md:text-md whitespace-nowrap">
                        {{ element.recordIndex }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="familyName">
                      <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap">{{ HEADER_ITEM_NAMES[1] }}</th>
                      <td mat-cell *matCellDef="let element" class="text-sm md:text-md whitespace-nowrap">
                        {{ element.familyName }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="firstName">
                      <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap">{{ HEADER_ITEM_NAMES[2] }}</th>
                      <td mat-cell *matCellDef="let element" class="text-sm md:text-md whitespace-nowrap">
                        {{ element.firstName }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="familyNameKana">
                      <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap">{{ HEADER_ITEM_NAMES[3] }}</th>
                      <td mat-cell *matCellDef="let element" class="text-sm md:text-md whitespace-nowrap">
                        {{ element.familyNameKana }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="firstNameKana">
                      <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap">{{ HEADER_ITEM_NAMES[4] }}</th>
                      <td mat-cell *matCellDef="let element" class="text-sm md:text-md whitespace-nowrap">
                        {{ element.firstNameKana }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="mail">
                      <th mat-header-cell *matHeaderCellDef class="whitespace-nowrap">{{ HEADER_ITEM_NAMES[5] }}</th>
                      <td mat-cell *matCellDef="let element" class="text-sm md:text-md whitespace-nowrap">
                        {{ element.email }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="authority">
                      <th mat-header-cell *matHeaderCellDef class="text-right">{{ HEADER_ITEM_NAMES[6] }}</th>
                      <td mat-cell *matCellDef="let element" class="text-right whitespace-nowrap">
                        <div class="inline-block text-sm whitespace-nowrap" *ngIf="element.isOrganizationAdmin === true">
                          <app-label-with-icon iconName="check_circle">団体管理ユーザー</app-label-with-icon>
                        </div>
                        <div class="inline-block text-sm whitespace-nowrap" *ngIf="element.isOrganizationAdmin === false">一般ユーザー</div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                  </table>
                </app-table-overflow>

                <div class="flex items-center justify-end">
                  <button class="md:min-w-[120px] md:h-12 md:text-base" mat-flat-button color="primary" (click)="deleteMembers()">
                    削除
                  </button>
                </div>
              </div>
            </div>
          </section>
        </app-content-row>
      </app-wrapper>
    </app-card-content>
  </app-content-row>
</app-wrapper>
